<template>
    <div class="tw:relative tw:flex tw:items-center tw:w-full">
        <!-- Icono a la izquierda (Prefix) -->
        <div v-if="prefixIcon"
            class="tw:absolute tw:left-4 tw:text-slate-400 tw:flex tw:items-center tw:pointer-events-none">
            <i :class="prefixIcon"></i>
        </div>

        <input
            class="tw:block tw:w-full tw:bg-neutral-50/50 tw:border tw:border-slate-200 tw:rounded-xl tw:text-sm tw:text-slate-800 tw:placeholder:text-slate-400 tw:focus:ring-2 tw:focus:ring-brand-primary/20 tw:focus:border-brand-primary tw:transition-all tw:outline-none tw:disabled:bg-slate-100 tw:disabled:border-slate-200 tw:disabled:text-slate-400"
            :class="[
                prefixIcon ? 'tw:pl-11' : 'tw:px-4',
                suffixIcon ? 'tw:pr-11' : 'tw:px-4',
                inputClass
            ]" v-bind="$attrs" :type="type" :value="value" :placeholder="placeholder" :disabled="disabled"
            :required="required" v-on="inputListeners" />

        <!-- Icono a la derecha (Suffix) -->
        <div v-if="suffixIcon"
            class="tw:absolute tw:right-4 tw:text-slate-400 tw:flex tw:items-center tw:pointer-events-none">
            <i :class="suffixIcon"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseInput',
    // La raíz es un <div>, así que sin esto atributos como min/max/step/maxlength/readonly
    // caerían en el contenedor en vez del <input> y quedarían inertes.
    inheritAttrs: false,
    computed: {
        // Reenvía al <input> los listeners del padre (@keyup, @change, @blur...) y
        // mantiene v-model emitiendo el valor en lugar del evento nativo.
        inputListeners() {
            return {
                ...this.$listeners,
                input: (event) => this.$emit('input', event.target.value),
            };
        },
        inputClass() {
            return {
                'tw:py-1.5': this.size === 'base',
                'tw:py-1 tw:text-xs tw:placeholder:text-xs tw:px-2!': this.size === 'sm',
                'tw:py-3': this.size === 'lg'
            }
        }
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        prefixIcon: {
            type: String,
            default: '' // Ejemplo: 'fas fa-envelope'
        },
        suffixIcon: {
            type: String,
            default: '' // Ejemplo: 'fas fa-check'
        },
        size: {
            type: String,
            default: 'base',
            validator: (value) => ['sm', 'base', 'lg'].includes(value)
        }
    },
}
</script>